import { Box, Button, Checkbox, Text } from '@factorialco/deprecated-design-system'
import { FieldArray, FormikProps, getIn } from 'formik'
import { AtsQuestionOptionInput } from 'generated/resources/graphql'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { CreateQuestionFormValues, UpdateQuestionFormValues } from './QuestionFormValues'

interface Props {
  form: FormikProps<CreateQuestionFormValues> | FormikProps<UpdateQuestionFormValues>
}

export const OptionsField = ({ form }: Props) => {
  return (
    <FieldArray
      name="options"
      render={(arrayHelpers) => (
        <Box gap="s16">
          {form.values.autoDisqualify && (
            <Text.Normal>
              {i18n.t(
                'ats.job_posting_settings.application_form.custom_questions.auto_disqualify_hint'
              )}
            </Text.Normal>
          )}

          {form.values.options.map((option: AtsQuestionOptionInput, index: number) => {
            const textFieldName = `options.${index}.text`
            const disqualifiesFieldName = `options.${index}.disqualifies`
            const error = getIn(form.touched, textFieldName) && getIn(form.errors, textFieldName)
            const onlyTwoOptionsLeft = (form.values.options?.length ?? 0) < 3

            return (
              <Box key={index} flexDirection="row" alignItems="center" gap="s16">
                {form.values.autoDisqualify && (
                  // This is a hack so the icon doesn't get missaligned when there is an error shown
                  <Box paddingBottom={error ? 's24' : undefined}>
                    <Checkbox
                      aria-label={i18n.t(
                        'ats.job_posting_settings.application_form.custom_questions.disqualifies_label',
                        { answer_text: option.text }
                      )}
                      name={disqualifiesFieldName}
                      checked={option.disqualifies || false}
                      onChange={(event) => {
                        form.setFieldValue(disqualifiesFieldName, event.target.checked)
                        form.setFieldTouched(disqualifiesFieldName)
                      }}
                    />
                  </Box>
                )}
                <TextField
                  placeholder={i18n.t(
                    'ats.job_posting_settings.application_form.custom_questions.option_placeholder',
                    {
                      position: index + 1,
                    }
                  )}
                  value={option.text}
                  onChange={(value) => {
                    form.setFieldValue(textFieldName, value)
                    form.setFieldTouched(textFieldName)
                  }}
                  error={error || !!form.errors.autoDisqualify}
                />
                {/* This is a hack so the icon doesn't get missaligned when there is an error shown */}
                <Box paddingBottom={error ? 's24' : undefined}>
                  <Button
                    type="secondary"
                    aria-label={i18n.t(
                      'ats.job_posting_settings.application_form.custom_questions.delete_option',
                      {
                        option,
                      }
                    )}
                    onClick={() => {
                      if (!onlyTwoOptionsLeft) {
                        arrayHelpers.remove(index)
                      }
                    }}
                    disabled={onlyTwoOptionsLeft}
                    iconName="delete"
                  />
                </Box>
              </Box>
            )
          })}

          {form.errors.autoDisqualify && (
            <Text.Normal color="radicalRed1000">{form.errors.autoDisqualify}</Text.Normal>
          )}

          <Button type="secondary" onClick={() => arrayHelpers.push({ text: '' })} iconName="add">
            {i18n.t('ats.job_posting_settings.application_form.custom_questions.add_option')}
          </Button>
        </Box>
      )}
    />
  )
}
